import {
    inject,
    Injector,
    runInInjectionContext,
    type Provider,
} from '@angular/core';
import { UserStore, injectUser } from '@quipex/core/auth';
import { FEATURE_FLAG, FeatureFlagService } from '@quipex/core/config';
import { BUILDING_CREATION_INTENT } from '@quipex/feature/buildings-find';
import { PermissionKey } from '@quipex/shared/contracts';

export function provideBuildingCreationIntent(): Provider {
    return {
        provide: BUILDING_CREATION_INTENT,
        useFactory: () => {
            const injector = inject(Injector);
            const user = inject(UserStore);
            const flags = inject(FeatureFlagService);
            const permitted = injectUser().hasPermission([
                PermissionKey.OrgBuildingCreate,
            ]);
            const requestsEnabled = flags.flagEnabled(
                FEATURE_FLAG.BuildingAccessRequests
            );
            return async (onReady?: () => void) => {
                if (!requestsEnabled() || !permitted()) return;
                const orgId = user.org()?.id;
                const { injectAddBuildingDialog } =
                    await import('@quipex/feature/buildings/add-building');
                if (
                    !requestsEnabled() ||
                    !permitted() ||
                    orgId !== user.org()?.id
                )
                    return;
                onReady?.();
                runInInjectionContext(injector, () =>
                    injectAddBuildingDialog().open()
                );
            };
        },
    };
}
